module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsSAAALEgHS3X78AAAAOklEQVQ4jWOgG/ifZ9MAwoTsY6KWg0YNoqNBjAzQKMajxh5KH8RpyKQjDVRzEUEwmiCHs0HUAQwMDABqAQ3APyqD+QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/@1x/ic_btn_plus.png
// module id = 305
// module chunks = 0